// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { memo } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import SocialBadgeList from "../SocialBadgeList"
import NewsLetterSignup from "../NewsLetterSingup"
import * as styles from "./styles.module.scss"

export interface SocialProps {
  facebookHandle?: string
  twitterHandle?: string
  githubHandle?: string
  companyLinkedinHandle?: string
  twitchHandle?: string
}

const Nav = ({ style }) => {
  return (
    <div className={style}>
      <ul className={styles.navList}>
        <li className={styles.navListItem}>
          <Link to="/">Home</Link>
        </li>
        <li className={styles.navListItem}>
          <Link to="/about-us">About Us</Link>
        </li>
        <li className={styles.navListItem}>
          <Link to="/careers">Careers</Link>
        </li>
        <li className={styles.navListItem}>
          <Link to="/blog">Blog</Link>
        </li>
        <li className={styles.navListItem}>
          <Link to="/press">Press</Link>
        </li>
      </ul>
    </div>
  )
}

const Legal = ({ style, logo }) => {
  return (
    <div className={style}>
      <div className={styles.logo}>
        <Link to="/">
          <Img fluid={logo} alt="One More Game Small Logo" />
        </Link>
      </div>
      <ul className={styles.legalList}>
        <li className={styles.legalItem}>
          <Link to="/legal/privacy-policy">Privacy Policy</Link>
        </li>
      </ul>
      <div className={styles.copyright}>
        Trademarks are properties of their respective owners
        <br />
        Copyright 2021, All Rights Reserved
      </div>
    </div>
  )
}

const Footer: React.FC<SocialProps> = (socialProps: SocialProps) => {
  const data = useStaticQuery(graphql`
    query {
      footerLogo: file(relativePath: { eq: "omg-logo-inverted.png" }) {
        childImageSharp {
          fluid(maxWidth: 72) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <footer>
      <NewsLetterSignup />
      <div className={styles.wrapper}>
        <Nav style={styles.col1} />
        <div className={styles.col2}>
          <SocialBadgeList
            listStyle={styles.socialList}
            listItemStyle={styles.socialItem}
            iconSize="2x"
            {...socialProps}
          />
        </div>
        <Legal
          style={styles.col3}
          logo={data.footerLogo.childImageSharp.fluid}
        />
      </div>
    </footer>
  )
}

export default memo(Footer)
